import React from 'react';
import './pullQuote.scss';
import quoteIcon from '../../Assets/quoteIcon.svg';

const PullQuoteWImg = ({ quote, author, descrip, photo }) => {
  return (
    <div className="pullQuoteWImg">
      <div className="pullQuoteWImg__graphic">
        <img src={quoteIcon} alt="quote graphic" />
      </div>
      <p className="pullQuoteWImg__quote">{quote}</p>
      <div className="pullQuoteWImg__headshot">
        <img src={photo} alt="man" />
      </div>

      <p className="pullQuoteWImg__author">{author}</p>
      <p className="pullQuoteWImg__title">{descrip}</p>
    </div>
  );
};

export default PullQuoteWImg;
